/* eslint-disable */ import { memoEval, violationsComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const tuscanSingleFeetBaseComponents = [
    attachComponent.withComponent(violationsComponent, 'default', true).withEntity('TuscanSingleFeetBase').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$violations
        ], ($violations)=>({
            violations: $violations
        })))
];

//# sourceMappingURL=tuscan-single-feet-base.js.map